<template src="./headerComponent.template.html"></template>

<script>
  // const socket = require('socket.io');


  export default {

    name: 'headerMenu',
    props: [],
    data() {
      return {
        headerPreview: null
      };
    },
    methods: {

    },
    computed: {
      isVaildSubDomain() {
        let vm = this;
        if (vm.$store.state.isValidDomainOrNot == true) {
          return true;
        }
        return false;
      },
      headerSection() {
        if (this.$store.state.beData.HeaderText)
          return this.$store.state.beData.HeaderText;
        return null
      },


    },
    created() {
    },
    watch: {

      headerSection() {
        //console.log(this.beCssObj);
        let vm = this;
        if (this.headerSection) {
          vm.headerPreview = `<html><head><style>${
            vm.$store.state.beData.HeaderStyle
            }</style></head><body>${vm.$store.state.beData.HeaderText}</body></html>`;
        }
      }
    },
    mounted() {
      // let vm = this;
      // console.log("headerPreview", vm.$store.state.styleObj)
      // vm.headerPreview = `<html><head><style>${
      //   vm.$store.state.styleObj
      //   }</style></head><body>${vm.$store.state.beData.HeaderText}</body></html>`;
     
      // console.log("vm.headerPreview", vm.headerPreview)

    }
  }

</script>


// WEBPACK FOOTER //
// src/components/homeModule/headerComponent/headerComponent.vue